module.exports = __webpack_public_path__ + "static/profile-section-848b6e9f7b073570afe1169b84ca1049.mp4";